import React, { Component } from 'react'
import Otp from './OtpBox'
import Backdrop from '../../../../component/Popup/Backdrop/Backdrop'
import classes from '../../signUp.module.css';
export class VerifyMobile extends Component {
      
    render() {
        
        return (
            <div className={this.props.show ? classes.Background : ''}>
            {/* <Backdrop open={this.props.show}/> */}
            <Otp saveHandler={this.props.saveHandler} closeModal={this.props.closeModalVerify} open={this.props.show} 
            mobileNumber={this.props.mobileNumber}
            email={this.props.email}/>
            </div>
        )
    }
}

export default VerifyMobile
